import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../..';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { CarrierRateSet } from '../../services/FP_FulfillmentContextService/types';
import type { ApplicationErrorOptions } from '../../../types';

export interface CarrierRateSetsModel {
  carrierRateSetsMap: Record<string, CarrierRateSet>;
  setCarrierRateSets: Action<CarrierRateSetsModel, CarrierRateSet[]>;
  setCarrierRateSet: Action<CarrierRateSetsModel, CarrierRateSet>;
  fetchCarrierRateSetsLoading: boolean;
  setFetchCarrierRateSetsLoading: Action<CarrierRateSetsModel, boolean>;
  fetchCarrierRateSets: Thunk<CarrierRateSetsModel, void, Injections, StoreModel, Promise<void>>;
  fetchCarrierRateSetsFailure: Action<CarrierRateSetsModel, ApplicationErrorOptions>;
}

export const carrierRateSetsModel: CarrierRateSetsModel = {
  carrierRateSetsMap: {},
  setCarrierRateSets: action((state, carrierRateSets) => {
    const carrierRateSetsMap = carrierRateSets.reduce<Record<string, CarrierRateSet>>((acc, curr) => {
      acc[curr.carrierRateSetId] = curr;
      return acc;
    }, {});
    state.carrierRateSetsMap = carrierRateSetsMap;
  }),
  setCarrierRateSet: action((state, carrierRateSet) => {
    state.carrierRateSetsMap[carrierRateSet.carrierRateSetId] = carrierRateSet;
  }),
  fetchCarrierRateSetsLoading: false,
  setFetchCarrierRateSetsLoading: action((state, isLoading) => {
    state.fetchCarrierRateSetsLoading = isLoading;
  }),
  fetchCarrierRateSets: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchCarrierRateSetsLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchCarrierRateSets();
      actions.setCarrierRateSets(response);
      actions.setFetchCarrierRateSetsLoading(false);
      return response;
    } catch (error) {
      actions.fetchCarrierRateSetsFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchCarrierRateSetsLoading(false);
      return error;
    }
  }),
  fetchCarrierRateSetsFailure: action((state, error) => {
    console.error(error);
  }),
};

export default carrierRateSetsModel;
